let isSupportWebp = 'unknown';
import { CDN_PATH } from '../../constants/variables';

let canIUseWebp = new Promise((resolve, reject) => {
    try {
        if (isSupportWebp === 'unknown') {
            isSupportWebp = 'loading';

            let elem = document.createElement('canvas');
            if (!!(elem.getContext && elem.getContext('2d'))) {
                isSupportWebp = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
            }

            if (!isSupportWebp || isSupportWebp === 'loading') {
                const webP = new Image();
                webP.onload = webP.onerror = function () {
                    isSupportWebp = webP.height === 2;
                    resolve(isSupportWebp);
                };
                webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';

            } else resolve(isSupportWebp);
        } else resolve(isSupportWebp);
    } catch (e) {
        console.error(e);
        reject(e);
    }

});

export default function getResizeImageUrl(options) {
    const CABIN_PATH = process.env.REACT_APP_CABIN_SERVICE;
    const ORIGIN_PATH = process.env.REACT_APP_CMS_API;

    const {typeResize, imageCabinId, imageAbsoluteUrl, height, width, webpQuality, otherQuality} = options;
    const prefix = CDN_PATH === '/' ? (ORIGIN_PATH.indexOf('localhost') !== -1 ? 'https://qa-www.s7.ru/' : ORIGIN_PATH + '/') : CDN_PATH;

    let image;

    if (imageCabinId) {
        image = `${prefix}${CABIN_PATH}/media/${imageCabinId}`;
    } else if (imageAbsoluteUrl) {
        image = imageAbsoluteUrl;
    } else return '';

    let imgUrl = `${prefix}api/v1/img/`;

    if (typeResize) {
        imgUrl += `${typeResize}/${width ? width + '/' : '*/'}${height ? height + '/' : '*/'}`;
    }

    let quality = otherQuality;

    if (isSupportWebp !== 'unknown' && isSupportWebp !== 'loading' && isSupportWebp) {
        imgUrl += 'webp/';
        quality = webpQuality;
    }

    if (isSupportWebp === 'unknown') {
        canIUseWebp.then(
            result => isSupportWebp = result,
            error => isSupportWebp = false
        )
    }

    if (!typeResize && !isSupportWebp) {
        imgUrl = image;
    } else {
        image = image.replace('https://', '').replace('http://', '');
        imgUrl += image;
    }

    let iopts = [];

    if (quality) {
        iopts.push("q:" + quality);
    }

    if (iopts.length > 0) {
        if (imgUrl.indexOf('?')===-1) {
            imgUrl += '?';
        } else {
            imgUrl += '&';
        }
        imgUrl += "iopts=" + iopts.join(";");
    }

    return imgUrl;
};